import React from "react";
import { PaperClipIcon } from "components/Icons";

import IconButton from "components/Buttons/IconButton";

export function attachmentIcon(active, onClick) {
  if (!active) return null;
  return (
    <PaperClipIcon
      className="h-8 w-8 text-slate-600 stroke-2 p-1 cursor-pointer hover:opacity-50"
      aria-hidden="true"
      onClick={onClick}
    />
  );
}

export function saveIcon(active, onClick) {
  if (!active) return null;
  return (
    <IconButton
      onClick={async () => await onClick("save")}
      name="button_save"
      color="gray"
    />
  );
}

export function deleteIcon(active, onClick) {
  if (!active) return null;
  return <IconButton onClick={onClick} name="button_delete" color="rose" />;
}
